// Noms d'événements PostHog du quiz funnel.
export const TRACKING_EVENTS = {
  PAGE_VIEW: "page_view",
  CTA_CLICK: "cta_click", // démarrage depuis la home
  CONTACT_OPENED: "contact_opened",
  FORM_PARTIAL_SUBMISSION: "form_partial_submission", // contact capturé
  QUIZ_STARTED: "quiz_started",
  QUIZ_QUESTION_ANSWERED: "quiz_question_answered",
  QUIZ_COMPLETED: "quiz_completed",
  LEAD_QUALIFIED: "lead_qualified",
  LEAD_DISQUALIFIED: "lead_disqualified",
} as const;
